import React, { useEffect, useRef, useState } from 'react';
import { FC } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useParams } from 'react-router';
import { Button, Dialog, Link, makeStyles, Slide } from '@material-ui/core';
import { Provider, useDispatch, useSelector } from 'react-redux';
import ReactDOMServer from 'react-dom/server';
import store, { RootState } from 'src/store';
import GetCodeModal from 'src/components/Modal/GetCodeModal';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import { API, Auth } from 'aws-amplify';
import { TransitionProps } from '@material-ui/core/transitions/transition';
import SettingsModal from 'src/components/Modal/SettingsModal';
import { editUserCompany } from 'src/store/modules/client';
import { editTemplateId, editTemplateName } from 'src/store/modules/template';

import { ReactComponent as Arrowleft } from 'src/assets/arrow-left.svg';
import { ReactComponent as ArrowNarrowUp } from 'src/assets/arrow-narrow-up.svg';
import { TEMPLATES_HTML } from 'src/constants/templatesComponent';
import { PLUS_TEMPLATES } from 'src/constants/templates';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    height: '3rem',
    minWidth: 1200,

    display: 'flex',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 100,

    backgroundColor: '#282828'
  },
  toolbar: {
    width: '100%',
    margin: 'auto',
    padding: '0 2rem',
    display: 'flex',

    justifyContent: 'space-between',
    alignItems: 'center'
  },
  homeText: {
    width: '14.159375rem',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',

    color: '#fff',
    fontSize: '0.875rem',
    fontWeight: 400,
    letterSpacing: '0.0175rem'
  },

  uploadBtn: {
    width: 112,
    height: 32,

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',

    outline: 'none',
    border: 'none',

    cursor: 'pointer',
    color: '#fff',
    fontSize: 12,
    fontWeight: 500,
    fontFamily: 'Archivo',
    textTransform: 'none',

    background: '#3D3D3D',
    '&:hover': {
      color: '#000000',
      background: '#f4f4f4'
    }
  },
  uploadIcon: {
    width: 16,
    height: 16,
    marginLeft: 4
  },
  saveBtn: {
    // width: '4.375rem',
    height: '2rem',
    margin: 'auto',
    padding: 0,

    outline: 'none',
    border: 'none',
    borderRadius: '0.5rem',

    cursor: 'pointer',
    color: '#fff',
    fontSize: '0.875rem',
    fontWeight: 400,
    fontFamily: 'Archivo',
    letterSpacing: '0.0175rem',

    background: '#3D3D3D',
    '&:hover': {
      color: '#000000',
      background: '#f4f4f4'
    }
  },
  exportBtn: {
    // width: '7.25rem',
    height: '2rem',
    margin: 'auto',
    padding: '0 1rem',

    outline: 'none',
    border: 'none',
    borderRadius: '0.5rem',

    cursor: 'pointer',
    color: '#fff',
    fontSize: '0.875rem',
    fontWeight: 400,
    fontFamily: 'Archivo',
    letterSpacing: '0.0175rem',

    background: '#3D3D3D',
    '&:hover': {
      color: '#000000',
      background: '#f4f4f4',
      a: {
        color: '#000000'
      }
    }
  },
  csvBtnWrapper: {
    height: '2rem',
    margin: 'auto',
    padding: 0,

    outline: 'none',
    border: 'none',
    borderRadius: '0.5rem',

    cursor: 'pointer',
    color: '#fff',
    fontSize: '0.875rem',
    fontWeight: 400,
    fontFamily: 'Archivo',
    letterSpacing: '0.0175rem',

    background: '#3D3D3D',
    '&:hover': {
      color: '#000000',
      background: '#f4f4f4',
      a: {
        color: '#000000'
      }
    }
  },
  csvBtn: {
    width: '100%',
    height: '2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    textDecoration: 'none',
    '&:hover': {
      color: '#000000'
    }
  },

  dialog: {
    top: 0,
    right: 0,
    position: 'fixed',
    width: '50%',
    margin: 0,
    height: '100%',
    maxHeight: 'max-content',
    borderRadius: 0
  },
  sizeIcon: {
    width: '1.5rem',
    height: '1.5rem',
    marginLeft: 12,
    border: 'none',

    cursor: 'pointer',
    borderRadius: '999px',
    backgroundColor: '#4F4F4F'
    // position: 'absolute',
    // top: 1
  },
  imageGuide: {
    position: 'absolute',
    top: 20,
    left: '98%'
  }
}));

const TopBar: FC = () => {
  const classes = useStyles();
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [exportHover, setExportHover] = useState(false);
  const [brazeCode, setBrazeCode] = useState<string | string[]>(
    '이 템플릿을 사용할 권한이 없습니다.'
  );
  const dispatch = useDispatch();
  const history = useHistory();
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [freeExpired, setFreeExpired] = useState(true);

  const handleModalClose = () => {
    setSettingsOpen(false);
  };

  let templateTitle = useSelector(
    (state: RootState) => state.template.templateTitle
  );
  let templateName = useSelector(
    (state: RootState) => state.template.templateName
  );
  // 변수 목록
  // 클라이언트
  let userCompany = useSelector((state: RootState) => state.client.userCompany);
  const [company, setCompany] = useState(userCompany);

  //
  let starIndex = useSelector(
    (state: RootState) => state.imageUpload.starIndex
  );
  let bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  let bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  let bgImageBlur = useSelector(
    (state: RootState) => state.imageUpload.bgImageBlur
  );
  let deeplink = useSelector((state: RootState) => state.imageUpload.deeplink);
  let radius = useSelector((state: RootState) => state.imageUpload.radius);

  let text = useSelector((state: RootState) => state.editText.text);
  let fontSize = useSelector((state: RootState) => state.editText.fontSize);
  let fontWeight = useSelector((state: RootState) => state.editText.fontWeight);
  let color = useSelector((state: RootState) => state.editText.color);
  let fontFamily = useSelector((state: RootState) => state.editText.fontFamily);
  let textAlign = useSelector((state: RootState) => state.editText.textAlign);

  let btnText = useSelector((state: RootState) => state.buttons.btnText);
  let btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  let btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  let btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  let btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  let btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  let btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  let btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  let btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  let btnTextAlign = useSelector(
    (state: RootState) => state.buttons.btnTextAlign
  );
  let btnAgain = useSelector((state: RootState) => state.buttons.btnAgain);

  let tracking = useSelector((state: RootState) => state.trackings.tracking);
  let button1 = useSelector((state: RootState) => state.trackings.button1);
  let button2 = useSelector((state: RootState) => state.trackings.button2);
  let logCustom = useSelector((state: RootState) => state.trackings.logCustom);

  const Transition = React.forwardRef(function Transition(
    props: TransitionProps & { children?: React.ReactElement<any, any> },
    ref: React.Ref<unknown>
  ) {
    return <Slide direction="left" ref={ref} {...props} />;
  });

  const FINAL_VALUES = {
    company: company,
    starIndex: starIndex,

    bgColor: bgColor,
    bgImage: bgImage,
    bgImageBlur: bgImageBlur,
    deeplink: deeplink,
    radius: radius,

    text: text,
    fontSize: fontSize,
    fontWeight: fontWeight,
    color: color,
    fontFamily: fontFamily,
    textAlign: textAlign,

    btnText: btnText,
    btnFontSize: btnFontSize,
    btnFontWeight: btnFontWeight,
    btnColor: btnColor,
    btnBgColorR: btnBgColorR,
    btnBgColorG: btnBgColorG,
    btnBgColorB: btnBgColorB,
    btnBgColorA: btnBgColorA,
    btnFontFamily: btnFontFamily,
    btnTextAlign: btnTextAlign,
    btnAgain: btnAgain,

    tracking: tracking,
    button1: button1,
    button2: button2,
    logCustom: logCustom
  };

  let TEMPLATE_TITLE = location?.pathname
    ?.split('/')?.[2]
    .toUpperCase()
    .split('-')
    .join(' ');

  useEffect(() => {
    async function onLoad() {
      // try {
      //   if (id && location.pathname.indexOf('survey') !== -1) {
      //     const current = await Auth.currentUserInfo();
      //     setCompany(current.attributes['custom:Company']);
      //     const { hash } = await API.get('iam-editor', `/hash/${id}`, '');
      //     setHash(hash);
      //   }
      // } catch (error) {
      //   console.log('error ', error);
      // }
      try {
        const data = await API.get('iam-editor', `/templates/${id}`, '');
        dispatch(editTemplateName(data?.templateName));
      } catch (error) {
        console.log(error);
      }

      try {
        const result = await API.get(
          'iam-editor',
          '/subscription/subscription-info',
          ''
        );
        editUserCompany(result?.companyName);
        setCompany(result?.companyName);
        if (
          result.subscriptionExpireDate &&
          result.subscriptionExpireDate - Date.now() > 0
        ) {
          setFreeExpired(false);
        } else if (
          // PLUS_TEMPLATES.indexOf(TEMPLATE_TITLE) === -1 &&
          result.freeTrialExpireDate &&
          result.freeTrialExpireDate - Date.now() > 0
        ) {
          setFreeExpired(false);
        } else {
          setFreeExpired(true);
        }
      } catch (error) {
        console.log('error: ', error);
      }
      // try {
      //   const current = await Auth.currentUserInfo();
      //   console.log(current);
      //   editUserCompany(current.attributes['custom:Company']);
      //   setCompany(current.attributes['custom:Company']);
      // } catch (error) {
      //   console.log('error ', error);
      // }
    }
    onLoad();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const htmlString = ReactDOMServer.renderToString(
    <Provider store={store}>{TEMPLATES_HTML[templateTitle]}</Provider>
  );
  async function handleExport(event: any) {
    event.preventDefault();
    if (freeExpired) {
      alert('구독 후 사용가능합니다.');
    } else {
      try {
        const returnId = await saveTemplate(id);
        if (returnId !== null) {
          dispatch(editTemplateId(returnId));
          history.push(
            `/editor/${templateTitle
              .toLowerCase()
              .split(' ')
              .join('-')}/${returnId}`
          );
        }

        // if (location.pathname.indexOf('survey') !== -1) {
        //   const { hash } = await API.get('iam-editor', `/hash/${returnId}`, '');
        //   setHash(hash);
        //   dispatch(editHash(hash));
        // }

        const isExport = await exportTemplate(returnId);
        if (isExport) {
          const htmlString = ReactDOMServer.renderToString(
            <Provider store={store}>{TEMPLATES_HTML[templateTitle]}</Provider>
          );
          const code = `<html>${htmlString}</html>`;
          const frontBody = code.split('<body>')[0];
          const bodyContent = `<body>${
            code.split('<body>')[1].split('</body>')[0]
          }</body>`;
          const backBody = code.split('</body>')[1];
          const CODE = [
            btoa(unescape(encodeURIComponent(frontBody))),
            bodyContent,
            btoa(unescape(encodeURIComponent(backBody)))
          ];
          setBrazeCode(CODE);
          setOpen(true);
        }
      } catch (error) {
        console.log('error', error.massage);
      }
    }
  }

  function exportTemplate(id: string) {
    return API.post('iam-editor', '/templates/export', {
      body: {
        htmlFile: htmlString,
        client: userCompany.replaceAll(' ', '-'),
        templateId: id
      }
    });
  }

  async function handleSave(e: any) {
    e.preventDefault();
    try {
      const returnId = await saveTemplate(id);
      if (returnId !== null) {
        alert('Save Successful');
        history.push(
          `/editor/${templateTitle
            .toLowerCase()
            .split(' ')
            .join('-')}/${returnId}`
        );
      }
    } catch (error) {
      console.log('error', error.massage);
    }
  }

  async function saveTemplate(id: string) {
    const current = await Auth.currentUserInfo();
    setCompany(current.attributes['custom:Company']);
    if (id) {
      return API.put('iam-editor', `/templates/${id}`, {
        body: {
          customValues: FINAL_VALUES,
          templateName: templateName === '' ? templateTitle : templateName,
          clientName: current.attributes['custom:Company'].replaceAll(' ', '-')
        }
      });
    } else {
      return API.post('iam-editor', '/templates/save', {
        body: {
          customValues: FINAL_VALUES,
          iamType: templateTitle,
          templateName: templateName === '' ? templateTitle : templateName,
          clientName: current.attributes['custom:Company'].replaceAll(' ', '-'),
          recommend: false
          // catalogSetId: ''
        }
      });
    }
  }

  return (
    <div className={classes.root}>
      <div className={classes.toolbar}>
        <Link
          component={RouterLink}
          to="/workspace/draft"
          className={classes.homeText}
        >
          <Arrowleft
            style={{
              width: '1.5rem',
              height: '1.5rem',
              marginRight: 8
            }}
          />
          <span>BACK</span>
        </Link>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            margin: 'auto'
          }}
        >
          <span
            style={{
              fontWeight: 600,
              color: '#fff'
            }}
          >
            {templateName === '' ? templateTitle : templateName}
          </span>
        </div>
        <div style={{ display: 'flex', gap: '1rem' }}>
          <Button className={classes.uploadBtn} onClick={handleSave}>
            <span>SAVE</span>
            <ArrowNarrowUp className={classes.uploadIcon} />
          </Button>
          <Button
            onClick={handleExport}
            onMouseOver={() => setExportHover(true)}
            onMouseLeave={() => setExportHover(false)}
            className={classes.uploadBtn}
          >
            <span>GET CODE</span>
            <ArrowNarrowUp className={classes.uploadIcon} />
          </Button>
        </div>

        <Dialog open={open} onClose={handleClose}>
          <GetCodeModal handleClose={handleClose} getCode={brazeCode} />
        </Dialog>
        <Dialog
          classes={{ paper: classes.dialog }}
          style={{ visibility: settingsOpen ? 'visible' : 'hidden' }}
          TransitionComponent={Transition}
          open={settingsOpen}
          onBackdropClick={handleModalClose}
          maxWidth={false}
        >
          <SettingsModal
            handleClose={handleModalClose}
            currentTab="subscription"
          />
        </Dialog>
      </div>
    </div>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func
};

TopBar.defaultProps = {
  onMobileNavOpen: () => {}
};

export default TopBar;
